import React from 'react'
import { Portal as ChakraPortal } from '@chakra-ui/react'
import { forwardRef } from '@hub/design-system-base'

export interface PortalProps {
  containerRef?: React.RefObject<HTMLElement | null>
  appendToParentPortal?: boolean
}

export const Portal = forwardRef<PortalProps, React.FC>(
  ({ containerRef, appendToParentPortal = false, children }) => (
    <ChakraPortal
      containerRef={containerRef}
      appendToParentPortal={appendToParentPortal}
    >
      {children}
    </ChakraPortal>
  )
)
